module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/ecomm/ecomm-02-c34ed65c8650e53321a4f68c98dcc809.jpg";